import 'core-js-pure/stable';
import 'regenerator-runtime/runtime';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { App } from './App';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import * as Dtos from './api/dtos'
import { RequestState } from './store/modules';
import { Router } from 'react-router-dom';
import createReduxStore from './store/createReduxStore';


declare let global: any; // populated from package.json/jest

if (typeof global === 'undefined') {
    (window as any).global = window;
}

const user = global.AUTH as Dtos.AuthenticateResponse

export const [store, history] = createReduxStore({
    authentication: {
        user,
        loadState: {
            state: RequestState.Success
        }
    }
});

const theme = createMuiTheme({
    typography: {
        h1: {
            fontSize: '3rem'
        },
        h2: {
            fontSize: '1.5rem'
        },
        h3: {
            fontSize: '1.25rem'
        }
    }
});

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme} >
            <Router history={history}>
                <App />
            </Router>
        </ThemeProvider>
    </Provider>,
  document.getElementById('root') as HTMLElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.tsx